import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.scss']
})
export class VideoListComponent implements OnInit {

  videoListArr: any = [
    {
      id: 1,
      category: 'Intoduction',
      details: [
        {
          id: 101,
          title: 'Spindle Driven Direct Warping Machine with V Creel',
          thumbnail: 'assets/img/blog/4.png',
          video: 'www.youtube.com/embed/NUooTKtmgz8'
        },
        {
          id: 102,
          title: 'Spindle Driven Direct Warping Machine with V Creel',
          thumbnail: 'assets/img/blog/3.png',
          video: 'www.youtube.com/embed/NUooTKtmgz8'
        },
        {
          id: 103,
          title: 'Spindle Driven Direct Warping Machine with V Creel',
          thumbnail: 'assets/img/blog/2.png',
          video: 'www.youtube.com/embed/NUooTKtmgz8'
        },
        {
          id: 104,
          title: 'Spindle Driven Direct Warping Machine with V Creel',
          thumbnail: 'assets/img/blog/1.png',
          video: 'www.youtube.com/embed/NUooTKtmgz8'
        }
      ]
    },
    {
      id: 2,
      category: 'Products',
      details: [
        {
          id: 201,
          title: 'Spindle Driven Direct Warping Machine with V Creel',
          thumbnail: 'assets/img/blog/1.png',
          video: 'www.youtube.com/embed/NUooTKtmgz8'
        },
        {
          id: 202,
          title: 'Spindle Driven Direct Warping Machine with H Creel',
          thumbnail: 'assets/img/blog/2.png',
          video: 'www.youtube.com/embed/EWt59RIkjY8'
        },
        {
          id: 203,
          title: 'Spindle Driven Direct Warping Machine with H Creel',
          thumbnail: 'assets/img/blog/3.png',
          video: 'www.youtube.com/embed/54n-nzoLOFg'
        },
        {
          id: 204,
          title: 'PLC Base Sizing Machine Suiting Shirting',
          thumbnail: 'assets/img/blog/4.png',
          video: 'www.youtube.com/embed/uYKBZhUGQHw'
        },
        {
          id: 205,
          title: 'PLC Base Sizing Machine Towel',
          thumbnail: 'assets/img/blog/5.png',
          video: 'www.youtube.com/embed/rwkw9SD8HZU'
        },
        {
          id: 206,
          title: 'Indigo Sheet Dyeing & Sizing Machine',
          thumbnail: 'assets/img/blog/6.png',
          video: 'www.youtube.com/embed/epLd0fbRu3E'
        }
      ]
    }
  ]
  currentTab: any = 1;
  currentIndDetail: any = [];

  constructor() { }

  ngOnInit() {
    this.currentIndDetail = this.videoListArr[0]?.details;
  }

  currentActiveCate(id, ind) {
    this.currentTab = id;
    this.currentIndDetail = this.videoListArr[ind]?.details;
  }

}
